import React from "react";
import {
	Typography,
	Stack,
	Box,
	Table,
	TableBody,
	TableRow,
	TableHead,
	TablePagination,
	Dialog,
	Modal,
	Snackbar
} from "@mui/material";
import { useState, useEffect, useRef } from "react";

import { StyledTableCellBody, StyledTableCellHeader, StyledTableContainer } from "../../components/ui/Table";
import { TextButton } from "../../components/ui/Buttons";
import { GreenBox, RedBox, YellowBox, BlueBox } from "../../components/ui/Chip";
import {
	GetSupportHistory,
	GetSingleSupportHistory,
	CancelRequest,
} from "../../services/support.services";
import CircularProgress from "@mui/material/CircularProgress";
import { LoadingBox } from "../../components/ui/Box";
// import moment from "moment";
import { ContainedButton } from "../../components/ui/Buttons";
import cancelRequestImg from "../../assets/cancelRequest.svg";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import moment from "moment";

export const modelStyle = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: "40%",
	height: "auto",
	bgcolor: "background.paper",
	borderRadius: "8px",
	p: 4,
	paddingLeft: "5%",
	paddingRight: "5%",
	boxShadow: "0px 5px 25px 2px rgba(49, 49, 49, 0.25)",
};

export default function TicketHistory() {
	const [open, setOpen] = useState(false);
	const [openCancel, setOpenCancel] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [supportHistory, setSupportHistory] = useState(null);
	const [supportSingleHistory, setSupportSingleHistory] = useState(null);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [totalElements, setTotalElements] = useState(0);
	const [supportId, setSupportId] = useState("");
	const [cancelRequest, setCancelRequest] = useState({
		encryptedId: "",
		status: "",
	});

	const [snackBarSuccess, setSnackBarSuccess] = useState(false);
	const [snackBarAlert, setSnackBarAlert] = useState(false);
	const hasRun = useRef(false);

	useEffect(() => {
		if (hasRun.current) return;
		hasRun.current = true;

		const fetchData = async () => {
			setIsLoading(true);
			try {
				await GetSupportHistory(page, rowsPerPage).then((data) => {
					   setSupportHistory(data.elements);
					   setTotalElements(data.totalElements);
				});
				setIsLoading(false);
			} catch (error) {
				console.error('Error', error);
				setIsLoading(false);
			}
		};

		fetchData();
	}, [page, rowsPerPage]);

	useEffect(() => {
		if (!supportId) return;

		const fetchSingleData = async () => {
			setIsLoading(true);
			try {
				await GetSingleSupportHistory(supportId).then((data) => {
					// Extract first element from the response
				   setSupportSingleHistory(data);
				});
				setIsLoading(false);
			} catch (error) {
				console.error('Error', error);
				setIsLoading(false);
			}
		};

		fetchSingleData();
	}, [supportId]);

	if (!supportHistory)
		return (
			<LoadingBox>
				<CircularProgress />
			</LoadingBox>
		);

	const handleClose = () => {
		setSupportId("");
		setCancelRequest({
			encryptedId: "",
			status: "",
		})
		setOpen(false);
	};

	const handleCancelModel = () => {
		handleClose();
		setOpenCancel(false);
	};

	const handleChangePage = (event, newPage) => {
		hasRun.current = false;
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		hasRun.current = false;
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	const handleOpen = (value) => {
		setSupportId(value);
		setCancelRequest({
			encryptedId: value,
			status: "CANCELLED"
		});
		setOpen(true);
	};

	const handleOpenCancelModel = () => {
		setOpenCancel(true);
	};

	const handleCancelRequest = () => {
		try {
			CancelRequest(cancelRequest).then((data) => {
				if (data.ok) {
					setSnackBarSuccess(true)
				} else {
					setSnackBarAlert(true);
				}
				handleCancelModel();
			});
		} catch (error) {
			setSnackBarAlert(true);
			console.error('Error', error);;
		}
	}

	return (
		<div>
			<Box
				sx={{
					p: 3,
					backgroundColor: "#FFFFFF",
					boxShadow: "0px 0px 4px rgba(3, 40, 120, 0.18)",
					borderRadius: "2px",
				}}
			>
				<br></br>
				<StyledTableContainer>
					<Table sx={{ minWidth: 650 }} aria-label="simple table">
						<TableHead>
							<TableRow sx={{ backgroundColor: "#F6F6F6" }}>
								<StyledTableCellHeader align="left">
									Date
								</StyledTableCellHeader>
								<StyledTableCellHeader align="left">
									Reference No
								</StyledTableCellHeader>
								<StyledTableCellHeader align="left">
									Issue Title
								</StyledTableCellHeader>
								<StyledTableCellHeader align="left">
									Issue Category
								</StyledTableCellHeader>
								<StyledTableCellHeader align="left">
									Status
								</StyledTableCellHeader>
								<StyledTableCellHeader align="center">
									Action
								</StyledTableCellHeader>
							</TableRow>
						</TableHead>
						<TableBody>
							{supportHistory
								.map((data, index) => (
									<>
										<TableRow key={index}>
											<StyledTableCellBody align="left">
												{moment(data.requestDate).format("MMM D, y")}
											</StyledTableCellBody>
											<StyledTableCellBody align="left">
													{data.referenceNo}
											</StyledTableCellBody>
											<StyledTableCellBody align="left">
													{data.ticketSubject}
											</StyledTableCellBody>
											<StyledTableCellBody align="left">
													{data.issueType}
											</StyledTableCellBody>
											<StyledTableCellBody align="left">
												{(() => {
													if (data.status === "IN_PROGRESS") {
														return (
															<BlueBox>
																<b>In-Progress</b>
															</BlueBox>
														);
													} else if (data.status === "PENDING") {
														return (
															<YellowBox>
																<b>Pending</b>
															</YellowBox>
														);
													} else if (data.status === "CANCELLED") {
														return (
															<RedBox>
																<b>Closed</b>
															</RedBox>
														);
													} else if (data.status === "RESOLVED") {
														return (
															<GreenBox>
																<b>RESOLVED</b>
															</GreenBox>
														);
													}
												})()}
											</StyledTableCellBody>
											<StyledTableCellBody align="center">
												<TextButton
													variant="text"
													onClick={() => handleOpen(data.encryptedId)}
												>
													View
												</TextButton>
											</StyledTableCellBody>
										</TableRow>
									</>
								))}
						</TableBody>
					</Table>
				</StyledTableContainer>
				<Dialog
					open={open}
					fullWidth
					maxWidth="sm"
					onClose={handleClose}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<Box sx={{ p: 6 }}>
						{!supportSingleHistory || isLoading ? (
							<LoadingBox>
								<CircularProgress />
							</LoadingBox>
						) : (
							<>
								<Stack
									direction="row"
									justifyContent="space-between"
									alignItems="center"
								>
									<Stack direction="row" alignItems="center" spacing={1}>
										<Typography variant="h4" textAlign="center">
											<b>Reference No:</b>
										</Typography>
										<Typography variant="h5_light" textAlign="center">
											{supportSingleHistory.referenceNo}
										</Typography>
									</Stack>

									<Stack direction="row" alignItems="center" spacing={1}>
										<Typography variant="h4" textAlign="center">
											<b>Status:</b>
										</Typography>
										{(() => {
											if (supportSingleHistory.status === "IN_PROGRESS") {
												return (
													<BlueBox>
														<b>In-Progress</b>
													</BlueBox>
												);
											} else if (supportSingleHistory.status === "PENDING") {
												return (
													<YellowBox>
														<b>Pending</b>
													</YellowBox>
												);
											} else if (supportSingleHistory.status === "CANCELLED") {
												return (
													<RedBox>
														<b>Closed</b>
													</RedBox>
												);
											} else if (supportSingleHistory.status === "RESOLVED") {
												return (
													<GreenBox>
														<b>RESOLVED</b>
													</GreenBox>
												);
											}
										})()}
									</Stack>
								</Stack>

								<br></br>
								<Stack>
									<Typography variant="h4"><b>Issue Title</b></Typography>
									<Typography variant="h5_light">
										{supportSingleHistory.ticketSubject}
									</Typography>
								</Stack>
								<br></br>
								<Stack>
									<Typography variant="h4"><b>Issue Category</b></Typography>
									<Typography variant="h5_light">
										{supportSingleHistory.issueType}
									</Typography>
								</Stack>
								<br></br>
								<Stack>
									<Typography variant="h4"><b>Issue Description</b></Typography>
									<Typography variant="h5_light">
										{supportSingleHistory.ticketDescription}
									</Typography>
								</Stack>

								<br></br>
								<br></br>
								<Stack
									direction="row"
									justifyContent="space-between"
									alignItems="center"
									spacing={2}
								>
									{supportSingleHistory.status === "PENDING" && (
										<TextButton
											variant="text"
											size="large"
											fullWidth
											onClick={() =>
												handleOpenCancelModel()
											}
										>
											Cancel Request
										</TextButton>
									)}

									<ContainedButton
										variant="contained"
										size="large"
										fullWidth
										onClick={handleClose}
									>
										Close
									</ContainedButton>
								</Stack>
							</>
						)}
					</Box>
				</Dialog>

				{/* cancel support Modal Start */}
				<Modal
					open={openCancel}
					onClose={handleCancelModel}
					aria-labelledby="modal-modal-title"
					aria-describedby="modal-modal-description"
				>
					<Box sx={modelStyle}>
						<br></br>
						<Stack alignItems="center">
							<img src={cancelRequestImg} alt="Logo" style={{ width: "30%" }} />
						</Stack>
						<br></br>
						<Stack sx={{ marginBottom: "10%" }} spacing={2}>
							<Typography
								id="modal-modal-title"
								variant="h2"
								textAlign="center"
							>
								<b>Cancel Request</b>
							</Typography>
							<Typography
								id="modal-modal-title"
								variant="h5_light"
								textAlign="center"
							>
								Support request will be canceled and marked as closed. You will
								not get contacted by our support team.
							</Typography>
						</Stack>
						<Stack alignItems="center" spacing={2}>

							<TextButton
								variant="text"
								size="large"
								fullWidth
								sx={{ width: "50%" }}
								onClick={() => {
									handleCancelModel();
								}}
							>
								Close
							</TextButton>
							<ContainedButton
								variant="contained"
								size="large"
								sx={{ width: "50%" }}
								onClick={() => {
									handleCancelRequest();
								}}
							>
								Confirm Cancel
							</ContainedButton>
						</Stack>
						<br></br>
					</Box>
				</Modal>
				{/* cancel support Modal End */}
				<TablePagination
					rowsPerPageOptions={[10, 25, 100]}
					component="div"
					count={totalElements}
					rowsPerPage={rowsPerPage}
					page={page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			</Box>
			<Snackbar
				open={snackBarSuccess}
				onClose={() => setSnackBarSuccess(false)}
				anchorOrigin={{ vertical: "top", horizontal: "left" }}
				sx={{ top: "0 !important", left: "0 !important" }}
				autoHideDuration={6000}
			>
				<Box
					onClose={() => setSnackBarSuccess(false)}
					sx={{ width: "100vw", background: "#00AD47", p: 0.5 }}
				>
					<Stack
						direction="row"
						spacing={2}
						sx={{
							width: "100%",
							textAlign: "center",
							alignItems: "center",
							justifyContent: "center",
							color: "#FFFFFF",
						}}
					>
						<CheckCircleOutlineOutlinedIcon fontSize="small" />{" "}
						<Typography variant="body2">
							Cancel request successful!
						</Typography>
					</Stack>
				</Box>
			</Snackbar>

			<Snackbar
				open={snackBarAlert}
				onClose={() => setSnackBarAlert(false)}
				anchorOrigin={{ vertical: "top", horizontal: "left" }}
				sx={{ top: "0 !important", left: "0 !important" }}
				autoHideDuration={6000}
			>
				<Box
					onClose={() => setSnackBarAlert(false)}
					sx={{ width: "100vw", background: "#F33535", p: 0.5 }}
				>
					<Stack
						direction="row"
						spacing={2}
						sx={{
							width: "100%",
							textAlign: "center",
							alignItems: "center",
							justifyContent: "center",
							color: "#FFFFFF",
						}}
					>
						<CancelOutlinedIcon fontSize="small" />{" "}
						<Typography variant="body2">
							Something went wrong please try again.
						</Typography>
					</Stack>
				</Box>
			</Snackbar>
		</div>
	);
}
